import React from 'react';
export function GameBox({ count, description }: { count: number; description: string }) {
  return (
    <div className='flex flex-col justify-center items-center p-5 max-w-[200px] w-[30%] rounded-xl text-center text-white  main-gr-bg-color'>
      <p className='text-sm font-bold text-white'>{count}</p>
      <p className='text-[10px] text-white '>{description}</p>
    </div>
  );
}
